import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p5 from '../assets/images/music1.gif';

const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                  <b> Enjoy Music with just a click...</b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p5} alt="" />
            </a>


          </div>

   

    


    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://allmusic.com/" className="btn btn-xl btn-light mr-4">
         AllMusic
        </a>
        <a href="https://music.apple.com/us/browse" className="btn btn-xl btn-dark">
        Apple Music
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://archive.org/details/etree" className="btn btn-xl btn-light mr-4">
         Live Music
        </a>
        <a href="http://soundcloud.com/" className="btn btn-xl btn-dark">
         Sound Cloud
        </a>
      </div>
    </section>


     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://soundclick.com/" className="btn btn-xl btn-light mr-4">
          Sound Click !
        </a>
        <a href="http://musopen.org/" className="btn btn-xl btn-dark">
          Musopen
        </a>
      </div>
    </section>




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <h2 className="mb-5">Where Words Fail, Music Speaks..<i className="fa fa-music fa-spin"></i></h2>
        </div>
        
      </div>
    </section>









     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://audiomack.com/" className="btn btn-xl btn-light mr-4">
         Audiomack
        </a>
        <a href="http://tubidy.mobi/" className="btn btn-xl btn-dark">
       Tubidy
        </a>
      </div>
    </section>






     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://last.fm/" className="btn btn-xl btn-light mr-4">
        Last Music
        </a>
        <a href="http://jamendo.com/" className="btn btn-xl btn-dark">
         Jamendo
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://reverbnation.com/" className="btn btn-xl btn-light mr-4">
        ReverbNation
        </a>
        <a href="http://www.amazon.com/s?bbn=334897011&rh=n%3A163856011%2Cn%3A%21195211011%2Cn%3A%21251258011%2Cn%3A318768011%2Cn%3A334896011%2Cn%3A334897011&qid=1339862629&tag=digitren08-20&ref=sr_ex_n_1" className="btn btn-xl btn-dark">
         Amazon Music
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://www.pastemagazine.com/noisetrade/music/" className="btn btn-xl btn-light mr-4">
         Paste Music
        </a>
        <a href="https://www.shopify.com/sell/music" className="btn btn-xl btn-dark">
         Shopify
        </a>
      </div>
    </section>




<section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <h2 className="mb-5">Music is Life itself ..<i className="fa fa-music fa-spin"></i></h2>
        </div>
        
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.spotify.com/gh/" className="btn btn-xl btn-light mr-4">
         Spotify
        </a>
        <a href="https://stereomood.com/" className="btn btn-xl btn-dark">
         Stereo Mood
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.thisismyjam.com/" className="btn btn-xl btn-light mr-4">
         Jam
        </a>
        <a href="https://www.npr.org/music/" className="btn btn-xl btn-dark">
        NPR
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://worldstarhiphop.com/videos/" className="btn btn-xl btn-light mr-4">
         World Star hiphop
        </a>
        <a href="https://www.discogs.com/" className="btn btn-xl btn-dark">
         Discogs
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://genius.com/" className="btn btn-xl btn-light mr-4">
         Genius
        </a>
        <a href="https://ytmp3.cc/youtube-to-mp3/" className="btn btn-xl btn-dark">
         Yt Mp3
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.sweetwater.com/" className="btn btn-xl btn-light mr-4">
        Sweet Water
        </a>
        <a href="https://www.deezer.com/us/" className="btn btn-xl btn-dark">
         Deezer
        </a>
      </div>
    </section>














    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
